import React from 'react';
import {Link} from "react-router-dom";

const Tattoo = (props) =>
	<Link to={'/works/'+props.id} className='tattoo anime'>
		<div className='img'>
			<img src={require('../../img/db/'+props.img[0])}/>
		</div>
		<div className='master'>{props.master}</div>
	</Link>

export default Tattoo;